import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {EscapeHotkeyDirective} from "../../../hotkey/directives/escape-hotkey.directive";

@Component({
	selector: "app-feedback-popup",
	templateUrl: "./feedback-popup.component.html",
	styleUrls: ["./feedback-popup.component.scss"],
	imports: [MatIcon, EscapeHotkeyDirective, TranslatePipe],
})
export class FeedbackPopupComponent {
	ticket: string;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<FeedbackPopupComponent>,
		public _translate: TranslateService,
	) {
		this.ticket = data.ticket;
	}
}
